import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["status", "testId", "alwaysShow"];
import React from 'react';
import FooterBlockResolvedView from './resolved';
import { SmartLinkStatus } from '../../../../../constants';

/**
 * Represents a FooterBlock, designed to contain elements and actions that should appear
 * at the bottom of a link card.
 * @public
 * @param {FooterBlockProps} FooterBlockProps
 * @see Block
 */
var FooterBlock = function FooterBlock(_ref) {
  var status = _ref.status,
    _ref$testId = _ref.testId,
    testId = _ref$testId === void 0 ? 'smart-footer-block' : _ref$testId,
    alwaysShow = _ref.alwaysShow,
    props = _objectWithoutProperties(_ref, _excluded);
  if (status !== SmartLinkStatus.Resolved && !alwaysShow) {
    return null;
  }
  return /*#__PURE__*/React.createElement(FooterBlockResolvedView, _extends({}, props, {
    testId: testId
  }));
};
export default FooterBlock;